import React, { Fragment } from 'react';
import { Helmet } from 'react-helmet';
import { filter, range, map, isUndefined, union, size, toString, omit, replace, cloneDeep, intersection, forEach } from 'lodash';
import { Button, Row, Col } from 'react-bootstrap';
import { connect } from 'react-redux';
import { url } from '../../constants/routes';
import './styles.css';
import sdk from '../../qoc-sdk';
import Navigation from '../../components/Navigation';
import Footer from '../../components/Footer';
import TextHero from '../../components/TextBanner';
import PropTypes from 'prop-types';
import {
  connect as reduxConnect,
  actions as allActions
} from '../../reducers/index';
//import Options from '../TrainingCompleted/options'

class PreQuestionnairePage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      role:
        JSON.parse(JSON.parse(localStorage.getItem('role')).value) || 'NONE',
      campus:
        JSON.parse(JSON.parse(localStorage.getItem('campus')).value) || 'NONE',
      instanceLinkUUID:
        JSON.parse(
          JSON.parse(localStorage.getItem('instanceLinkUUID')).value
        ) || 'NONE'
    };
    this.onClickOption = this.onClickOption.bind(this);
    this.onClickSubmit = this.onClickSubmit.bind(this);
  }
  onClickOption(event) {
    // event.preventDefault();
    if (event.target.id === 'checkbox') {
      const currentState = cloneDeep(this.state);
      if (currentState[event.target.value] && currentState[event.target.value].surveyLinkUUID) {
        //remove surveyLinkUUID so it will not post
        this.setState({
          [event.target.value]: {
            value: event.target.value,
          }
        });
      } else {
        this.setState({
          [event.target.value]: {
            surveyLinkUUID: event.target.name,
            value: event.target.value,
            id: "checkbox"
          }
        });
      }
    } else {
      this.setState({
        [event.target.name]: {
          surveyLinkUUID: event.target.name,
          value: event.target.value,
        }
      });
    }
  }
  onClickSubmit() {
    const { cache } = this.props;
    const { campus, role } = this.state;

    const responsesToPost = filter(this.state, item => {
      if (!isUndefined(item.surveyLinkUUID)) {
        return item;
      }
    });
    const propsToPost = map(responsesToPost, item => {
      const propToPost = {
        surveyLinkUUID: item.surveyLinkUUID,
        responseSetId: `${campus}-${role}`,
        instanceLinkUUID: this.state.instanceLinkUUID,
        recordChangeDateTime: new Date().getTime(),
        responseDataType: 'numeric',
      };
      if (item.id === 'checkbox' 
		|| item.surveyLinkUUID.includes('likertScale')) {
        propToPost['responseOptionUUID'] = item.value
      } else {
        propToPost[sdk.utils.getResponseKey({ responseDataType: 'numeric' })] = item.value
      }

      return propToPost;
    });
    const roleProps = map(
      filter(cache.questions, question => {
        if (question.questionID === 'role') {
          return question;
        }
      }),
      item => {
        const propToPost = {
          surveyLinkUUID: item.surveyLinkUUID,
          instanceLinkUUID: this.state.instanceLinkUUID,
          responseSetId: `${campus}-${role}`,
          recordChangeDateTime: new Date().getTime(),
          responseDataType: 'string',
          [sdk.utils.getResponseKey({ responseDataType: 'string' })]: this.state
            .role
        };
        return propToPost;
      }
    );

    const campusProps = map(
      filter(cache.questions, question => {
        if (question.questionID === 'campus') {
          return question;
        }
      }),
      item => {
        const propToPost = {
          surveyLinkUUID: item.surveyLinkUUID,
          instanceLinkUUID: this.state.instanceLinkUUID,
          responseSetId: `${campus}-${role}`,
          recordChangeDateTime: new Date().getTime(),
          responseDataType: 'string',
          [sdk.utils.getResponseKey({ responseDataType: 'string' })]: this.state
            .campus
        };
        return propToPost;
      }
    );

    const finalPropsToPost = union(campusProps, roleProps, propsToPost);
    sdk
      .postPutSurveyResponsesNoCache({ surveyResponses: finalPropsToPost })
      .then(fulfilprops => {
        if (fulfilprops.status === 200) {
          this.context.router.history.push(url.IDENTIFY);
        }
      });
    // this.context.router.history.push(url.IDENTIFY);
  }

  render() {
    const { role, cache } = this.props;
    let Options = cache.options.options;
    const renderQuestions = filter(cache.questions, question => {
      if (question.questionID.indexOf('pre') !== -1
		&& question.deleted == false	
		) {
        return question;
      }
    }).map((question, index) => {
      let renderOptions;
      if (question.questionID.indexOf('checkbox') !== -1) {
        renderOptions = map( Options[question.questionID],
          (option) => {
            return (
              <label key={option} style={{ marginLeft: 0 }} className="radio-inline" onClick={this.onClickOption} >
                <input type="checkbox" id={'checkbox'} name={question.surveyLinkUUID} value={option.optionUUID} />&nbsp;
                {option.optionText}
              </label>
            );
          }
        );
      }else if (question.questionID.indexOf('likert') !== -1) {

        const legend = {
          1: "Yes",
          2: "No",
          3: "Not Sure"
        }
        renderOptions = map( Options[question.questionID],
          (option) => {
            return (
				// Manoj 20240704: Loop through questions. Render a row for each question.
			  <tr>
				<td>
					  {option.optionText}
				</td>
				{map(legend, (legendVal) => {
						// Manoj 20240704: Loop through the legend and render each cell
						return(
						<td>
							  <label key={option.optionUUID} style={{ marginLeft: 0 }} className="likert-option-cell" onClick={this.onClickOption} >
								<input type="radio" id={''} name={`[${question.questionID}][${option.optionUUID}]`} value={legendVal} />&nbsp;&nbsp;{legendVal}&nbsp;&nbsp;&nbsp;&nbsp;
							  </label>
						</td>
						)
				})}
			  </tr>
            );
          }
        );
		renderOptions = <table>{renderOptions}</table>;
	
		
      } else {
        const legend = {
          1: "Strongly Disagree",
          2: "Disagree",
          3: "Neutral",
          4: "Agree",
          5: "Strongly Agree",
        }
        renderOptions =
          question.questionID.indexOf('analogScale') !== -1
            ? map(range(1, question.maxValue + 1), (option, optionIndex) => {
              return (
                <label key={option} className="radio-inline">
                  <input
                    type="radio"
                    aria-checked={
                      !isUndefined(this.state[question.surveyLinkUUID]) &&
                        toString(this.state[question.surveyLinkUUID].value) ===
                        toString(option)
                        ? 'true'
                        : 'false'
                    }
                    name={question.surveyLinkUUID}
                    value={option}
                    tabIndex={optionIndex === 0 ? '0' : '-1'}
                    onChange={this.onClickOption}
                  />
                  {option}
                  <br />
                  {legend[option]}
                </label>
              );
            })
            : null;
      }

      let questionText = question.questionText;

      return (
        <div style={{ marginBottom: '30px' }} key={questionText}>
          <p>{`${index + 1}. ${questionText}`}</p>
          <div
            role="radiogroup"
            aria-labelledby="gdesc1"
            style={{
              display: question.questionID.indexOf('checkbox') !== -1 || question.questionID.indexOf('likert') !== -1? '' : 'flex',
              justifyContent: 'space-around',
              border: '1px solid #D5D5D5',
              padding: '10px'
            }}
          >
            {renderOptions}
          </div>
        </div>
      );
    });

    const checkAnswered = () => {
	console.log("checkAnswered");
	console.log("This.state = ");
	console.log(this.state);
	console.log("This.state object keys: ");
	console.log(Object.keys(this.state));
	let stateKeys = Object.keys(this.state);
	window.statekeys = stateKeys;

	const q1answered = filter(stateKeys, item => item.includes("question_1")).length > 0;

	const q2Opt1answered = filter(stateKeys, item => item.includes("question_2][opt_1")).length > 0;
	const q2Opt2answered = filter(stateKeys, item => item.includes("question_2][opt_2")).length > 0;
	const q2Opt3answered = filter(stateKeys, item => item.includes("question_2][opt_3")).length > 0;
	const q2Opt4answered = filter(stateKeys, item => item.includes("question_2][opt_4")).length > 0;
	const q2Opt5answered = filter(stateKeys, item => item.includes("question_2][opt_5")).length > 0;
	const q2answered = q2Opt1answered && q2Opt1answered && q2Opt3answered && q2Opt4answered && q2Opt5answered;

	const q3answered = filter(stateKeys, item => item.includes("question_3")).length > 0;

	const q4Opt1answered = filter(stateKeys, item => item.includes("question_4][opt_1")).length > 0;
	const q4Opt2answered = filter(stateKeys, item => item.includes("question_4][opt_2")).length > 0;
	const q4Opt3answered = filter(stateKeys, item => item.includes("question_4][opt_3")).length > 0;
	const q4Opt4answered = filter(stateKeys, item => item.includes("question_4][opt_4")).length > 0;
	const q4Opt5answered = filter(stateKeys, item => item.includes("question_4][opt_5")).length > 0;
	const q4answered = q4Opt1answered && q4Opt1answered && q4Opt3answered && q4Opt4answered && q4Opt5answered;

	const q5answered = filter(stateKeys, item => item.includes("question_5")).length > 0;

	const q6Opt1answered = filter(stateKeys, item => item.includes("question_6][opt_1")).length > 0;
	const q6Opt2answered = filter(stateKeys, item => item.includes("question_6][opt_2")).length > 0;
	const q6Opt3answered = filter(stateKeys, item => item.includes("question_6][opt_3")).length > 0;
	const q6Opt4answered = filter(stateKeys, item => item.includes("question_6][opt_4")).length > 0;
	const q6Opt5answered = filter(stateKeys, item => item.includes("question_6][opt_5")).length > 0;
	const q6answered = q6Opt1answered && q6Opt1answered && q6Opt3answered && q6Opt4answered && q6Opt5answered;
	
		
	
	console.log("q1answered = ");
	console.log(q1answered);
	console.log("q2answered = ");
	console.log(q2answered);
	console.log("q3answered = ");
	console.log(q3answered);
	console.log("q4answered = ");
	console.log(q4answered);
	console.log("q5answered = ");
	console.log(q5answered);
	console.log("q6answered = ");
	console.log(q6answered);


	let allAnswered =  q1answered && q2answered && q3answered && q4answered && q5answered && q6answered; 

	console.log("allAnswered = ");
	console.log(allAnswered);
	
	return allAnswered;
/*
      const answers = omit(this.state, [
        'role',
        'campus',
        'instanceLinkUUID',
        'undefined'
      ]);

      const experience = [
        '0BC4BDE6-4460-4D5B-A519-B6C1ADBA5FD8',
        'F0144207-F089-46C4-9AD5-5E29B604AEE1',
        'DFFAD34D-755C-4A95-A852-5772DD66AD79',
        'CB42379E-1761-470E-A520-1E6D1586FFE5',
      ];

      let includeExperience = 0;
      forEach(experience, (value) => {
        if (this.state[value] && this.state[value].surveyLinkUUID) {
          includeExperience = 1
        }
      })

      const referral = [
        '601D5FA5-5C93-42D8-B733-66FD30A1A54A',
        '3F98E2B4-6E96-410B-8DEE-00568A5CC349',
        'C293AF2B-CB83-4D52-8D35-6BE8502205BB',
        'FA43251A-3D99-4BF6-84F1-3B49F7F1B229'
      ];

      let includeReferral = 0;
      forEach(referral, (value) => {
        if (this.state[value] && this.state[value].surveyLinkUUID) {
          includeReferral = 1
        }
      })

      return ((size(answers) + includeExperience + includeReferral) === 7);
*/
	
		
	
    };

    return (
      <div className="education-module pre-questionnaire">
		  <style>
		  {`
		     /* Manoj 20240704 - Disclaimer: Tried to move this to style.scss in this directory, but wasn't loading on the browser, so i'm adding this here for now. Please, move this out in the future..*/

		    .likert-option-cell{
		        text-wrap: nowrap;	
		    }	
		`}
		</style>
        <Helmet>
          <title>Pre-Questionnaire</title>
        </Helmet>
        <Navigation role={role} />
        <TextHero childTitle={''} />
        <section
          style={{
            marginTop: '-100px'
          }}
        >
          <div className="container">
            <Row>
              <Col xs={10} xsOffset={1}>
                <h1
                  style={{ fontSize: '30px' }}
                  className="text-center txt-blue no-bold"
                >
                  Before We Begin
                </h1>
                <p>
                  <span className="bold">Learning Objectives</span><br />
                  The Identify, Assist, Refer training is intended to accomplish the following:
                  </p>
                <ul>
                  <li>Help you identify when someone is experiencing a mental health challenge</li>
                  <li>Guide you in holding assistive conversations</li>
                  <li>Facilitate help-seeking behaviour through effective referrals</li>
                </ul>

                <p>
                  <span className="bold">Navigation</span><br />
                At any time during this training, you may access the following pages by hovering to the top right:
                </p>
                <ul>
                  <li><span className="bold">Resources:</span> List of on- and off- campus resources for students, staff and faculty</li>
                  <li><span className="bold">Quick Guide:</span> A summary of Identify, Assist, Refer</li>
                  <li><span className="bold">Emergency:</span>  If you are feeling distressed at any point during this training, please refer to the University of Toronto’s Safety & Support resources</li>
                </ul>
                <p>
                  <span className="bold">Safety</span><br />
                  If you or someone you’re supporting is feeling distressed at any point during this training, please access the Emergency
                  tab for a list of University of Toronto's Safety & Support Resources. <strong>Please note:</strong> If you are experiencing
                  a crisis, please consider calling your healthcare provider, <a
                      href="https://health811.ontario.ca/static/guest/home"
                      target="_blank"
                      rel="noopener noreferrer"
                    >Health811
                    </a>, or accessing support through <a 
	    	      href="https://mentalhealth.utoronto.ca/telus-health-student-support/"
                      target="_blank"
                      rel="noopener noreferrer"
		    >U of T Telus Health Student Support</a> or <a 
	    	      href="https://good2talk.ca/"
                      target="_blank"
                      rel="noopener noreferrer"
	    	>Good2Talk</a>. If you are in immediate danger, call 911 and if on campus, 911 and then Campus Safety.
                </p>
	    	<p>
                  <span className="bold">Training Preparation</span><br />
		  This training will take approximately 30 minutes to complete and includes interactive activities and assessment surveys. It is recommended to allocate 30 minutes for completion to avoid survey resets. 
	    	</p>
                <p>
                  <span className="bold">Pre-Questionnaire</span><br />
                  Before you get started, please reflect on your current knowledge and confidence in being able to effectively
                  Identify, Assist, and Refer someone you’re concerned about. <strong>The “submit” button will not
                  appear until every question is answered.</strong>
                </p>
                <p>
                  Some questions appear on a Likert scale. On a scale of 1 to 5, 1 being strongly disagree and 5 being strongly agree,
                  please indicate your agreement with the following statements:
                </p>
              </Col>
            </Row>
            <Row className="questionnaire-section">
              <Col xs={10} xsOffset={1} md={8} mdOffset={2}>
                {renderQuestions}
              </Col>
            </Row>
          </div>
        </section>
        <section>
          <div className="container">
            <Row className="text-center">
              <Button
                className="btn btn-blue previous"
                onClick={() => this.props.history.goBack()}
              >
                Previous
              </Button>
              {checkAnswered() && (
                <Button
                  className="btn btn-blue next"
                  onClick={this.onClickSubmit}
                >
                  Submit
                </Button>
              )}
            </Row>
          </div>
        </section>
        <Footer />
      </div>
    );
  }
}

PreQuestionnairePage.propTypes = {
  role: PropTypes.object.isRequired // eslint-disable-line react/forbid-prop-types
};

PreQuestionnairePage.defaultProps = {
  role: {}
};

PreQuestionnairePage.contextTypes = {
  router: PropTypes.object.isRequired
};
const mapStateToProps = state => ({
  responses: state.cache.responses,
  cache: state.cache
});
const PreQuestionnaire = connect(
  mapStateToProps,
  allActions
)(PreQuestionnairePage);

export default reduxConnect.role(PreQuestionnaire);



// WEBPACK FOOTER //
// ./src/containers/PreQuestionnaire/index.jsx